(function () {
  'use strict';

  var PROXY_URL = '/apps/paymentstatussync/delivery/product-promise';
  var POLL_MS = 90000;
  var MOD_PREFIX = 'pdp-promise--';
  var COUNTDOWN_RE = /(\d+h\s*)?\d+m\s*\d+s/i;

  function esc(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function fmtHMS(totalSec) {
    var t = Math.max(0, Math.floor(totalSec));
    var h = Math.floor(t / 3600);
    var m = Math.floor((t % 3600) / 60);
    var s = t % 60;
    var str = '';
    if (h > 0) str += h + 'h ';
    str += (m < 10 ? '0' + m : '' + m) + 'm ';
    str += (s < 10 ? '0' + s : '' + s) + 's';
    return str.trim();
  }

  function fmtDeadline(isoStr) {
    var d = new Date(isoStr);
    if (isNaN(d)) return '';
    var h = d.getHours();
    var mn = d.getMinutes();
    var ampm = h >= 12 ? 'PM' : 'AM';
    h = h % 12 || 12;
    return h + ':' + (mn < 10 ? '0' + mn : '' + mn) + '\u202f' + ampm;
  }

  function resolveLine(displayLine, fallback) {
    var line = String(displayLine || '').trim();
    return line || String(fallback || '').trim();
  }

  function modForStatus(status) {
    switch (status) {
      case 'same_day_available': return 'same-day';
      case 'extra_day_required': return 'extra-day';
      case 'route_unavailable': return 'unavailable';
      case 'variant_unavailable': return 'unavailable';
      case 'out_of_stock': return 'unavailable';
      case 'guest_static': return 'guest';
      case 'address_missing': return 'address';
      case 'expired': return 'expired';
      default: return 'unknown';
    }
  }

  function splitCountdownLine(displayLine) {
    var match = String(displayLine || '').match(COUNTDOWN_RE);
    if (!match || match.index == null) return null;
    return {
      before: displayLine.slice(0, match.index),
      after: displayLine.slice(match.index + match[0].length)
    };
  }

  function ProductDeliveryPromise(el) {
    this.el = el;
    this.variantId = el.getAttribute('data-variant-id');
    this.pollTimer = null;
    this.cdTimer = null;
    this.cdRemaining = 0;
    this.requestId = 0;
    this._bound = {
      onVariantChange: this._onVariantChange.bind(this),
      onVisibilityChange: this._onVisibilityChange.bind(this)
    };
    this._init();
  }

  ProductDeliveryPromise.prototype._init = function () {
    window.addEventListener('product-variant-switch', this._bound.onVariantChange);
    document.addEventListener('variant:changed', this._bound.onVariantChange);
    document.addEventListener('variantChanged', this._bound.onVariantChange);
    document.addEventListener('variant-change', this._bound.onVariantChange);
    document.addEventListener('visibilitychange', this._bound.onVisibilityChange);
    this._showLoading();
    this._fetch();
    this._schedulePoll();
  };

  ProductDeliveryPromise.prototype._readQuantity = function () {
    var form = this.el.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    if (!form) return 1;
    var input = form.querySelector('[name="quantity"]');
    if (!input) return 1;
    var qty = parseInt(String(input.value || '1'), 10);
    return qty > 0 ? qty : 1;
  };

  ProductDeliveryPromise.prototype._onVariantChange = function (e) {
    var detail = e && e.detail ? e.detail : {};
    var variant = detail.variant || {};
    var vid = detail.variantId || variant.id;
    if (!vid) return;
    vid = String(vid);
    if (vid === this.variantId) return;
    this.variantId = vid;
    this.el.setAttribute('data-variant-id', vid);
    this._stopCountdown();
    this._showLoading();
    this._clearPoll();
    this._fetch();
    this._schedulePoll();
  };

  ProductDeliveryPromise.prototype._onVisibilityChange = function () {
    if (document.hidden) {
      this._clearPoll();
      return;
    }
    this._fetch();
    this._schedulePoll();
  };

  ProductDeliveryPromise.prototype._fetch = function () {
    if (typeof window === 'undefined') return;
    var self = this;
    var vid = this.variantId;
    if (!vid) return;

    var requestId = ++this.requestId;
    var qty = this._readQuantity();
    var url = PROXY_URL + '?variant_id=' + encodeURIComponent(vid) + '&quantity=' + encodeURIComponent(String(qty));

    fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        return r.json().catch(function () { return null; }).then(function (body) {
          return { ok: r.ok, body: body };
        });
      })
      .then(function (result) {
        if (requestId !== self.requestId) return;
        var data = result.body;
        if (!result.ok || !data || data.success === false || !data.productDeliveryPromise) {
          self._hide();
          return;
        }
        if (data.variantId && String(data.variantId) !== String(vid)) {
          self._hide();
          return;
        }
        self._applyTrace(data.traceId);
        self._render(data.productDeliveryPromise);
      })
      .catch(function () {
        if (requestId !== self.requestId) return;
        self._hide();
      });
  };

  ProductDeliveryPromise.prototype._applyTrace = function (traceId) {
    if (!traceId) {
      this.el.removeAttribute('data-trace-id');
      return;
    }
    this.el.setAttribute('data-trace-id', traceId);
  };

  ProductDeliveryPromise.prototype._schedulePoll = function () {
    var self = this;
    this._clearPoll();
    this.pollTimer = setInterval(function () {
      if (!document.hidden) self._fetch();
    }, POLL_MS);
  };

  ProductDeliveryPromise.prototype._clearPoll = function () {
    if (this.pollTimer) {
      clearInterval(this.pollTimer);
      this.pollTimer = null;
    }
  };

  ProductDeliveryPromise.prototype._stopCountdown = function () {
    if (this.cdTimer) {
      clearInterval(this.cdTimer);
      this.cdTimer = null;
    }
  };

  ProductDeliveryPromise.prototype._startCountdown = function (initialSec) {
    var self = this;
    this.cdRemaining = Math.max(0, Math.floor(initialSec));
    this.cdTimer = setInterval(function () {
      self.cdRemaining = Math.max(0, self.cdRemaining - 1);
      var span = self.el.querySelector('[data-pdp-cd]');
      if (span) span.textContent = fmtHMS(self.cdRemaining);
      if (self.cdRemaining <= 0) {
        self._stopCountdown();
        var expiredLine = self.el.getAttribute('data-i18n-expired') || 'Same-day window has closed for today';
        self._setInner('expired', expiredLine, '', null, null);
      }
    }, 1000);
  };

  ProductDeliveryPromise.prototype._setInner = function (mod, mainText, disclaimer, cdInit, countdownParts) {
    var classes = MOD_PREFIX + mod;
    var html = '<div class="pdp-promise__inner ' + classes + '">';
    html += '<span class="pdp-promise__icon" aria-hidden="true"></span>';
    html += '<span class="pdp-promise__text">';
    html += '<span class="pdp-promise__line">';

    if (countdownParts) {
      html += esc(countdownParts.before);
      html += '<span class="pdp-promise__countdown" data-pdp-cd>' + esc(fmtHMS(cdInit || 0)) + '</span>';
      html += esc(countdownParts.after);
    } else if (cdInit !== null) {
      var parts = mainText.split('{countdown}');
      html += esc(parts[0] || '');
      html += '<span class="pdp-promise__countdown" data-pdp-cd>' + esc(fmtHMS(cdInit)) + '</span>';
      html += esc(parts[1] || '');
    } else {
      html += esc(mainText);
    }

    html += '</span>';

    if (disclaimer) {
      html += '<span class="pdp-promise__disclaimer">' + esc(disclaimer) + '</span>';
    }

    html += '</span>';
    html += '</div>';

    this.el.innerHTML = html;
    this.el.hidden = false;
  };

  ProductDeliveryPromise.prototype._showLoading = function () {
    var line = this.el.getAttribute('data-i18n-loading') || 'Checking delivery options\u2026';
    this._setInner('loading', line, '', null, null);
    this.el.hidden = false;
  };

  ProductDeliveryPromise.prototype._hide = function () {
    this.el.hidden = true;
  };

  ProductDeliveryPromise.prototype._appendBadge = function (label, type) {
    var inner = this.el.querySelector('.pdp-promise__inner');
    if (!inner) return;
    var text = inner.querySelector('.pdp-promise__text');
    if (!text) return;
    var badge = document.createElement('span');
    badge.className = 'pdp-promise__badge' + (type === 'extra' ? ' pdp-promise__badge--extra' : '');
    badge.textContent = label;
    text.appendChild(badge);
  };

  ProductDeliveryPromise.prototype._render = function (promise) {
    this._stopCountdown();

    var status = promise.status || '';
    var displayLine = resolveLine(promise.displayLine, '');
    var disclaimer = promise.disclaimer || '';

    if (!displayLine) {
      this._hide();
      return;
    }

    var mod = modForStatus(status);

    if (status === 'extra_day_required') {
      this._setInner(mod, displayLine, disclaimer, null, null);
      this._appendBadge('+ 1 day', 'extra');
      return;
    }

    if (status === 'same_day_available') {
      var seconds = typeof promise.countdownSeconds === 'number' ? promise.countdownSeconds : 0;
      var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (seconds <= 0) {
        this._setInner(mod, displayLine, disclaimer, null, null);
        return;
      }

      if (reducedMotion) {
        var staticTime = fmtDeadline(promise.orderByDeadline) || fmtHMS(seconds);
        var reducedLine = displayLine.replace(COUNTDOWN_RE, staticTime);
        this._setInner(mod, reducedLine, disclaimer, null, null);
      } else {
        var countdownParts = splitCountdownLine(displayLine);
        if (countdownParts) {
          this._setInner(mod, displayLine, disclaimer, seconds, countdownParts);
          this._startCountdown(seconds);
        } else {
          this._setInner(mod, displayLine, disclaimer, null, null);
        }
      }

      this._appendBadge('SAME DAY', 'same-day');
      return;
    }

    this._setInner(mod, displayLine, disclaimer, null, null);
  };

  function initAll() {
    var els = document.querySelectorAll('[data-pdp-promise]');
    for (var i = 0; i < els.length; i++) {
      if (!els[i]._pdpPromise) {
        els[i]._pdpPromise = new ProductDeliveryPromise(els[i]);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var els = (e.target || document).querySelectorAll('[data-pdp-promise]');
    for (var i = 0; i < els.length; i++) {
      if (!els[i]._pdpPromise) {
        els[i]._pdpPromise = new ProductDeliveryPromise(els[i]);
      }
    }
  });
})();
